export default [
    {tag: 'scratch', intlLabel: 'Scratch'},
    {tag: 'tw', intlLabel: 'TurboWarp'},
    {tag: 'geko', intlLabel: 'Geko'},
    {tag: 'rc', intlLabel: 'rCodenow'}
];